/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_MergeInputs */



/**
* | output |
* | --- |
* | "Merge" |
*
* @param {Vekn_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge = /** @type {((inputs?: Vekn_MergeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_MergeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mesclar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci")
	return /** @type {LocalizedString} */ ("Merge")
});